import React from 'react';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Slider } from 'antd';

const LEVELS = Array.from({ length: 11 }, (_, i) => i);

const marks = LEVELS.reduce((acc, i) => {
    acc[i / 10] = i === 0 || i === 10 ? String(i / 10) : (i / 10).toFixed(1);
    return acc;
}, {});

const KOverlapSlider = (props) => {
    const translate = useTranslate();

    const formatter = (value) => {
        const level = Math.round(value * 10);
        if (!LEVELS.includes(level)) return value;
        return (
            <div>
                <div style={{ fontWeight: 600 }}>
                    K = {(level / 10).toFixed(1)} — {translate.formatMessage(commonMessage[`kOverlapTitle${level}`])}
                </div>
                <div>{translate.formatMessage(commonMessage[`kOverlapDesc${level}`])}</div>
            </div>
        );
    };

    return (
        <Slider
            min={0}
            max={1}
            step={0.1}
            style={{ margin: '0 10px' }}
            marks={marks}
            tooltip={{ formatter }}
            {...props}
        />
    );
};

export default KOverlapSlider;
